import { useEffect, useRef, useState } from 'react';

import {
  Col,
  Form,
  Row,
  Modal,
  Button
} from 'react-bootstrap';

import styles from './LoginSistemas.module.css';
import { phoneMask, cpfMask } from '../../helpers/masks';
import BriefingThumb from '../BriefingThumb';
import { AiFillCloseCircle } from 'react-icons/ai';

const sistemasSuporte = [
  'eSUS APS+',
  'eSUS notifica',
  'SIPNI',  
  'CADWEB',  
  'SISCAN', 
  'CNES',
  'BPA',
  'RAAS',
  'SINNC (Observatório)',
  'Outros' 
];

const sistemasLogin = [
  'eSUS APS+',
  'eSUS notifica',
  'SIPNI',  
  'CADWEB',  
  'SISCAN',
  'SINNC (Observatório)',
  'E-Gestor/Bolsa Família'
];

const LoginSistemas = props => {
  const suporteArquivo1Ref = useRef();
  const suporteArquivo2Ref = useRef();
  const suporteArquivo3Ref = useRef();
  const suporteArquivo4Ref = useRef();
  const suporteArquivo5Ref = useRef();

  const [sistemasArray, setSistemasArray] = useState([]);

  useEffect(() => {
    (props.suporteArquivo1 ||
      props.suporteArquivo2 ||
      props.suporteArquivo3 ||
      props.suporteArquivo4 ||
      props.suporteArquivo5) &&
      window.scrollBy(0, 350);
  }, [props.suporteArquivo1, props.suporteArquivo2, props.suporteArquivo3, props.suporteArquivo4, props.suporteArquivo5]);

  useEffect(() => {
    if (props?.loginSuporte?.tipo === 'login') {
      setSistemasArray(sistemasLogin);
    } else if (props?.loginSuporte?.tipo === 'suporte') {
      setSistemasArray(sistemasSuporte);
    } else {
      setSistemasArray([]);
    }
  }, [props?.loginSuporte?.tipo]);

  return (
    <>
      <Row className={styles.title}>Sistemas de Saúde</Row>
      <Row className={styles.options}>
        <Row className={styles.subtitle}>*Login ou Suporte?</Row>
        <Row>
          <Col sm={12}>
            <Form.Check
              className={styles.checkbox}
              type="radio"
              label="Login"
              value="login"
              name="tipo"
              id="login"
              onChange={e => props.handleLoginSuporte(e)}
              inline
            />
            <Form.Check
              className={styles.checkbox}
              type="radio"
              label="Suporte"
              value="suporte"
              name="tipo"
              id="suporte"
              onChange={e => props.handleLoginSuporte(e)}
              inline
            />
          </Col>
        </Row>
      </Row>

      {props.loginSuporte.tipo && (
        <Row>
          <Col sm={6}>
            <Form.Group controlId="loginSistemas" className="mt-4">
              <Form.Label>*Sistema:</Form.Label>
              <Form.Select
                className="border border-secondary"
                required
                name="loginSistemas"
                onChange={e => props.handleLoginSistemas(e)}
                value={props.loginSistemas}
              >
                <option value="">Selecione o Sistema:</option>
                {sistemasArray.map(sistema => (
                  <option key={sistema} value={sistema}>{sistema}</option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>
      )}

      {(props.loginSuporte.tipo === 'login') && props.loginSistemas && (props.loginSistemas !== 'CNES' && props.loginSistemas !== 'BPA' && props.loginSistemas !== 'RAAS' && props.loginSistemas !== 'Outros') && (
        <>
          <Row>
            <Col sm={6}>
              <Form.Group controlId="unidade" className="mt-4">
                <Form.Label>*Lotação:</Form.Label>
                <Form.Select
                  className="border border-secondary"
                  name="unidade"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.unidade}
                >
                  <option value="" disabled>Selecione a lotação</option>
                  {props.unidadesSistema && props.unidadesSistema.map(item => (
                    <option key={item.nomeCnes} value={item.nomeCnes}>{`${item.nomeGenerico} - ${item.nomeCnes}`}</option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Group controlId="nome" className="mt-4">
                <Form.Label>*Nome Completo:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="nome"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.nome}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group controlId="cpf" className="mt-4">
                <Form.Label>*CPF:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="cpf"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={cpfMask(props.loginSuporte.cpf)}
                  maxLength={14}
                />
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Group controlId="cns" className="mt-4">
                <Form.Label>*CNS:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="cns"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.cns}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={4}>
              <Form.Group controlId="equipe" className="mt-4">
                <Form.Label>*Equipe:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="equipe"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.equipe}
                />
              </Form.Group>
            </Col>

            <Col sm={4}>
              <Form.Group controlId="cbo" className="mt-4">
                <Form.Label>*CBO:</Form.Label>
                <Form.Control
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  required
                  name="cbo"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.cbo}
                  maxLength={6}
                />
              </Form.Group>
            </Col>

            <Col sm={4}>
              <Form.Group controlId="registroProfissional" className="mt-4">
                <Form.Label>Registro Profissional:</Form.Label>
                <Form.Control
                  type="text"
                  name="registroProfissional"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.registroProfissional}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col sm={6}>
              <Form.Group controlId="email" className="mt-4">
                <Form.Label>*e-mail:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="email"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={props.loginSuporte.email}
                />
              </Form.Group>
            </Col>

            <Col sm={6}>
              <Form.Group controlId="telefone" className="mt-4">
                <Form.Label>*Telefone:</Form.Label>
                <Form.Control
                  type="text"
                  required
                  name="telefone"
                  onChange={e => props.handleLoginSuporte(e)}
                  value={phoneMask(props.loginSuporte.telefone)}
                />
              </Form.Group>
            </Col>
          </Row>
        </>
      )}

      {props.loginSuporte.tipo === 'suporte' && (
        <>
          <Row>
            <p className={styles.file_title}>
              Enviar anexo. (Máximo de 5 anexos com 5MB cada) <br />
              Arquivos suportados: .pdf, .png, .gif, .jpg, .jpeg, .svg, .txt, .doc, .docx, .xls, .xlsx, .avi, .mp4, .mov
            </p>
          </Row>

          <Row>
            <Col sm={7}>
              <Form.Group controlId="suporteArquivo1" className="mt-4">
                <Form.Label>1º Anexo</Form.Label>
                <Form.Control
                  type="file"
                  className="border border-secondary"
                  name="suporteArquivo1"
                  onChange={e => props.handleSuporteArquivo(e, suporteArquivo1Ref)}
                  ref={suporteArquivo1Ref}
                />
              </Form.Group>
            </Col>

            <Col sm={1}>
              {props.suporteArquivo1 &&
                <AiFillCloseCircle
                  className={styles.file_reset_button}
                  onClick={() => props.resetSuporteArquivo(suporteArquivo1Ref)}
                  size={22}
                />
              }
            </Col>

            <BriefingThumb
              briefingArquivo={props.suporteArquivo1}
            />
          </Row>

          {(props.suporteArquivo1 || props.suporteArquivo2) &&
            <Row>
              <Col sm={7}>
                <Form.Group controlId="suporteArquivo2" className="mt-4">
                  <Form.Label>2º Anexo</Form.Label>
                  <Form.Control
                    type="file"
                    className="border border-secondary"
                    name="suporteArquivo2"
                    onChange={e => props.handleSuporteArquivo(e, suporteArquivo2Ref)}
                    ref={suporteArquivo2Ref}
                  />
                </Form.Group>
              </Col>

              <Col sm={1}>
                {props.suporteArquivo2 &&
                  <AiFillCloseCircle
                    className={styles.file_reset_button}
                    onClick={() => props.resetSuporteArquivo(suporteArquivo2Ref)}
                    size={22}
                  />
                }
              </Col>

              <BriefingThumb
                briefingArquivo={props.suporteArquivo2}
              />
            </Row>
          }

          {(props.suporteArquivo2 || props.suporteArquivo3) &&
            <Row>
              <Col sm={7}>
                <Form.Group controlId="suporteArquivo3" className="mt-4">
                  <Form.Label>3º Anexo</Form.Label>
                  <Form.Control
                    type="file"
                    className="border border-secondary"
                    name="suporteArquivo3"
                    onChange={e => props.handleSuporteArquivo(e, suporteArquivo3Ref)}
                    ref={suporteArquivo3Ref}
                  />
                </Form.Group>
              </Col>

              <Col sm={1}>
                {props.suporteArquivo3 &&
                  <AiFillCloseCircle
                    className={styles.file_reset_button}
                    onClick={() => props.resetSuporteArquivo(suporteArquivo3Ref)}
                    size={22}
                  />
                }
              </Col>

              <BriefingThumb
                briefingArquivo={props.suporteArquivo3}
              />
            </Row>
          }

          {(props.suporteArquivo3 || props.suporteArquivo4) &&
            <Row>
              <Col sm={7}>
                <Form.Group controlId="suporteArquivo4" className="mt-4">
                  <Form.Label>4º Anexo</Form.Label>
                  <Form.Control
                    type="file"
                    className="border border-secondary"
                    name="suporteArquivo4"
                    onChange={e => props.handleSuporteArquivo(e, suporteArquivo4Ref)}
                    ref={suporteArquivo4Ref}
                  />
                </Form.Group>
              </Col>

              <Col sm={1}>
                {props.suporteArquivo4 &&
                  <AiFillCloseCircle
                    className={styles.file_reset_button}
                    onClick={() => props.resetSuporteArquivo(suporteArquivo4Ref)}
                    size={22}
                  />
                }
              </Col>

              <BriefingThumb
                briefingArquivo={props.suporteArquivo4}
              />
            </Row>
          }

          {(props.suporteArquivo4 || props.suporteArquivo5) &&
            <Row>
              <Col sm={7}>
                <Form.Group controlId="suporteArquivo5" className="mt-4">
                  <Form.Label>5º Anexo</Form.Label>
                  <Form.Control
                    type="file"
                    className="border border-secondary"
                    name="suporteArquivo5"
                    onChange={e => props.handleSuporteArquivo(e, suporteArquivo5Ref)}
                    ref={suporteArquivo5Ref}
                  />
                </Form.Group>
              </Col>

              <Col sm={1}>
                {props.suporteArquivo5 &&
                  <AiFillCloseCircle
                    className={styles.file_reset_button}
                    onClick={() => props.resetSuporteArquivo(suporteArquivo5Ref)}
                    size={22}
                  />
                }
              </Col>

              <BriefingThumb
                briefingArquivo={props.suporteArquivo5}
              />
            </Row>
          }

          <Modal show={props.showSuporteModal} onHide={props.handleSuporteModalClose}>
            <Modal.Header closeButton>
              <Modal.Title>Erro</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.suporteError}</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={props.handleSuporteModalClose}>
                Fechar
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}

      <Modal show={props.showLoginSistemasModal} onHide={props.handleLoginSistemasModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Erro</Modal.Title>
        </Modal.Header>
        <Modal.Body>{props.loginSistemasError}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={props.handleLoginSistemasModalClose}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LoginSistemas;
